export const clearApiCallState = (type: string) => ({ type: `${type}Clear` });